<template>
  <div class="promotion-wrap">
    <div class="header-wrap">
      <div class="header-title">国内推广报表</div>
      <div class="filter-wrap">
        <div class="filter-item" style="margin-left: 0">
          <span class="filter-title">日期</span>
          <el-date-picker
            class="data-range"
            v-model="filterData.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMMdd"
            format="yyyy-MM-dd"
            :clearable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="filter-item">
          <span class="filter-title">维度</span>
          <el-select v-model="filterData.dimension" placeholder="请选择维度">
            <el-option
              v-for="item in dimensionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-title">产品</span>
          <product-select
            ref="pkgList"
            class="multiple-select"
            :value.sync="filterData.pkgList"
            multiple
          ></product-select>
        </div>
        <!-- <div class="filter-item">
          <span class="filter-title">地区</span>
          <areaMultiSelect
            ref="countryList"
            :value.sync="filterData.countryList"
            :optionsList="geoList"
          >
          </areaMultiSelect>
        </div> -->
        <div class="filter-item">
          <span class="filter-title">单位</span>
          <div class="cny-group flex">
            <el-button
              class="cny-btn"
              @click="changeCny(false)"
              :class="{ cur: !filterData.isCny }"
              >$
            </el-button>
            <el-button
              class="cny-btn"
              @click="changeCny(true)"
              :class="{ cur: filterData.isCny }"
              >￥
            </el-button>
          </div>
        </div>
        <el-button @click="handleReset" style="margin-left: 20px"
          >重置</el-button
        >
        <el-button @click="handerSearch" type="primary">查询</el-button>
      </div>
    </div>
    <div class="table-wrap">
      <div class="download-wrap">
        <!-- 选择字段弹框 -->
        <select-field
          :defaultIndexName="defaultIndexName"
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :type="21"
          :showAttributionData="false"
          :isHasFixed="false"
          style="margin-left: auto"
          btnText="选择渠道"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-download"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        ref="table"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa' }"
        :row-style="tableRowStyle"
        v-loading="tableLoading"
        @sort-change="handleSortChange"
      >
        <el-table-column
          prop="statDate"
          label="日期"
          v-if="dimension === 1"
          sortable="statDate"
          width="120"
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.statDate ? scope.row.statDate : "--" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="appName"
          label="产品名"
          v-if="dimension === 5"
          width="200"
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.appName ? scope.row.appName : "--" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          fixed
          label="地区"
          v-if="dimension === 2"
        >
          <template slot-scope="scope">
            {{ scope.row.country ? scope.row.country : "--" }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" width="170">
          <template slot="header">
            <span>推广总计</span>
          </template>
          <template slot-scope="scope">
            {{ `${isCny ? "￥" : "$"}${scope.row.allPlatCost}` }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableCols"
          :prop="item.value"
          :label="item.label"
          :key="item.value"
          sortable="custom"
          :min-width="185"
        >
          <template slot-scope="scope">
            <span>
              {{
                scope.row.platCostMap[item.value] !== "-"
                  ? `${isCny ? "￥" : "$"}${scope.row.platCostMap[item.value]}`
                  : scope.row.platCostMap[item.value]
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changeSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import SelectField from "@/components/selectField.vue";
import { dimensionList } from "./config";
// import areaMultiSelect from "@/components/areaMultiSelect.vue";
import { getMediaSourceList } from "@/api/api";
import { getPromotionReport } from "@/api/report.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import moment from "moment";
import { pickerOptions } from "@/config/enum.js";

export default {
  components: {
    // areaMultiSelect,
    SelectField,
  },
  data() {
    return {
      dimensionList,
      pickerOptions,
      dateConfigList: [],
      filterData: {
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        dimension: 1,
        pkgList: [],
        countryList: [],
        isCny: true,
      },
      isCny: false,
      dimension: 1,
      geoList: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableData: [],
      tableLoading: false,
      dynamicColumn: [],
      tableCols: [],
      dynamicSign: [],
      downloadLoading: false,
      // 需要排序的字段
      sortTableAttribute: null,
      // 降序1 升序2
      sortOrder: null,
      fieldOptions: [{ title: "渠道类型", list: [] }],
      defaultIndexName: {
        fixed: [],
        custom: [],
      },
      staticOptions: [],
    };
  },
  watch: {},
  mounted() {
    // getCountryListFetch().then((res) => {
    //   this.geoList = res.countryList.filter((item) =>
    //     ["CN", "HK", "TW", "MO"].includes(item.geo)
    //   );
    // });
    getMediaSourceList({
      isAbroad: 0,
    }).then((res) => {
      this.fieldOptions[0].list = [];
      this.dynamicColumn = [];
      this.defaultIndexName = {
        fixed: [],
        custom: [
          "bytedance_int",
          "tencent_int",
          "kuaishou_int",
          "huaweiads_int",
        ],
      };
      if (this.defaultIndexName.custom.length == 0) {
        res.data.map((item) => {
          this.defaultIndexName.custom.push(item);
        });
      }
      res.data.map((item) => {
        this.fieldOptions[0].list.push({
          label: item,
          value: item,
        });
        this.dynamicColumn.push({
          label: item,
          value: item,
          id: item,
        });
      });
    });
  },
  methods: {
    downloadReport() {
      const { countryList, dimension, time, pkgList, isCny } = this.filterData;
      const params = {
        countryList: countryList,
        dimension: dimension,
        startDate: moment(time[0]).format("YYYYMMDD"),
        endDate: moment(time[1]).format("YYYYMMDD"),
        pageNum: 1,
        pageSize: 100000,
        pkgList: pkgList,
        isCny,
        mediaList: this.tableCols.map((item) => item.id),
      };
      this.downloadLoading = true;
      getPromotionReport(params).then((res) => {
        if (res.code === "0000") {
          // 构造表头
          let headerData = {};
          if (this.filterData.dimension === 1) {
            // 日期
            headerData["statDate"] = "日期";
          } else if (this.filterData.dimension === 5) {
            // 产品
            headerData["appName"] = "产品";
          } else {
            // 地区
            headerData["country"] = "地区";
          }

          headerData["allPlatCost"] = "推广总计";
          this.tableCols.forEach((item) => {
            headerData[item.value] = item.label;
          });
          // 构造数据
          const dataList = (res.data.tableDataList || [])?.map((item) => {
            let platCostMapObj = Object.keys(item.platCostMap);
            let resultObj = item;
            platCostMapObj.forEach((i) => {
              resultObj[i] = `${isCny ? "￥" : "$"}${item.platCostMap[i]}`;
            });
            // 总计添加符号
            let itemObj = Object.keys(item);
            itemObj.forEach((i) => {
              if (i === "allPlatCost") {
                resultObj[i] = `$${resultObj[i]}`;
              }
            });

            return resultObj;
          });
          downLoadWrokSheet(dataList, "国内推广报表.xlsx", headerData);
          this.downloadLoading = false;
        }
      });
    },
    generateCols(colData, editFrom = "isTemplateIndex") {
      if (editFrom === "isCustomIndex") {
        this.defaultIndexName = JSON.parse(JSON.stringify(colData));
      }
      const timer = setInterval(() => {
        if (this.dynamicColumn?.length > 0) {
          if (colData.custom.concat(colData.fixed).length === 0) {
            //赋值默认表格列
            colData.custom = this.dynamicColumn;
          }
          clearInterval(timer);
          let tableCols = [];
          colData.fixed.forEach((item) => {
            let findItem = this.dynamicColumn.find(
              (colItem) => colItem.value == item
            );
            if (findItem) {
              tableCols.push(findItem);
            }
          });
          colData.custom.forEach((item) => {
            let findItem = this.dynamicColumn.find(
              (colItem) => colItem.value == item
            );
            if (findItem) {
              tableCols.push(findItem);
            }
          });
          this.tableCols = [];
          this.$nextTick(() => {
            this.tableCols = tableCols;
            // 选择指标后清除排序指标
            this.sortTableAttribute = "";
            this.sortOrder = null;
            setTimeout(() => {
              this.handerSearch();
            }, 500);
          });
        }
      }, 100);
    },
    // 表格排序
    handleSortChange({ prop, order }) {
      if (order) {
        this.sortTableAttribute = prop;
        this.sortOrder = order === "descending" ? 1 : 2;
      } else {
        this.sortTableAttribute = null;
        this.sortOrder = null;
      }

      this.getList();
    },
    tableRowStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return {
          background: "#f5f7fa",
        };
      }
      return "";
    },
    handleReset() {
      this.filterData = {
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        dimension: 1,
        pkgList: [],
        countryList: [],
        isCny: false,
      };
      this.dimension = 1;
      this.handerSearch();
    },
    handerSearch() {
      this.pageData.page = 1;
      this.pageData.total = 0;
      this.sortTableAttribute = null;
      this.sortOrder = null;
      this.$refs.table?.clearSort();
      this.$nextTick(() => {
        this.getList();
      });
    },
    changeCny(flag) {
      if (this.filterData.isCny === flag) return;
      this.filterData.isCny = flag;
    },
    getList() {
      const { countryList, dimension, time, pkgList, isCny } = this.filterData;
      this.dimension = dimension;
      this.isCny = isCny;
      const { page, size } = this.pageData;
      const params = {
        countryList: countryList,
        dimension: dimension,
        endDate: moment(time[1]).format("YYYYMMDD"),
        mediaList: this.tableCols.map((item) => item.id),
        pageNum: page,
        pageSize: size,
        pkgList: pkgList,
        isCny,
        startDate: moment(time[0]).format("YYYYMMDD"),
      };
      // 排序字段
      if (this.sortTableAttribute || this.sortOrder) {
        params["sortField"] = this.sortTableAttribute;
        params["sortValue"] = this.sortOrder;
      }

      this.tableLoading = true;
      getPromotionReport(params)
        .then((res) => {
          if (res.code === "0000") {
            const tableList = res.data.tableDataList
              ? res.data.tableDataList.map((item, index) => {
                  if (index === 0) {
                    return {
                      ...item,
                      statDate: "总计",
                      country: "总计",
                    };
                  }

                  return item;
                })
              : [];
            this.tableData = tableList;
            this.dynamicSign = res.data.platTypeHeaders;
            this.pageData.total = res.data.totalNum ? res.data.totalNum : 0;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changeSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.promotion-wrap {
  height: calc(100vh - 100px);
  padding: 16px;
  .header-wrap {
    padding: 16px 24px 16px 24px;
    border-radius: 4px;
    background-color: white;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    .header-title {
      align-items: center;
      display: flex;
      align-items: center;
      padding: 0px 16px 6px 0px;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
  }
  .filter-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 16px;
    .filter-item {
      margin-left: 25px;
      display: flex;
      align-items: center;
      .filter-title {
        font-size: 14px;
        margin-right: 15px;
      }
      .multiple-select {
        width: 300px;
        /deep/ .el-tag.el-tag--info:first-child {
          max-width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .data-range {
        position: relative;
        /deep/.el-range__icon {
          position: absolute;
          right: 6px;
          top: 0px;
        }
        /deep/.el-range-separator {
          line-height: 28px;
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
  }

  .table-wrap {
    margin-top: 15px;
    background-color: white;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px;
    .download-wrap {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 15px;
      .top-btn {
        color: #1890ff;
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid #1890ff;
        background: rgba(255, 255, 255, 1);
        margin-left: 12px;
        .pl-icon {
          margin-right: 8px;
        }
      }
    }

    .page-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .cny-group {
    display: inline-block;
    font-weight: 400;
    margin-left: 4px;
    .cur {
      background-color: #1890ff;
      border-color: #1890ff;
      color: #fff;
    }
    .cny-btn {
      width: 28px;
      height: 24px;
      margin-left: 0px;
      padding: 6px 8px;
      font-size: 12px;
    }
  }
}
</style>
